import MagicLinkOtpVerification from './MagicLinkOtpVerification';

export default MagicLinkOtpVerification;
